export default __webpack_public_path__ + "static/media/customisation.b8b06f91.svg";